module.exports = __webpack_public_path__ + "components/flag/static/square/cf-212b111bb742cba54e0de4de7f7d7003.svg";